import React, { useMemo } from 'react';
import moment from "moment";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { OrangeChip, OutlineChip, PrimaryChip } from '@shared/ui/atoms/Chip';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { User } from '@shared/models/user.models';
import { ApprovalState } from '@features/holidays/models/approval-requests.models';
import { isCompanyAdminUser } from '@shared/utils/AccessControl';
import { CustomLeaveGrouping } from "../../models/Holidays.model";
import { LeaveTypeLabel } from "./LeaveTypeLabel";
import { DateRange, SpaceBetweenRow } from "./UsersHolidayBookingItem";

export function CustomLeaveBookingItem(props: Props) {
  const { grouping, currentUser, userInfo, isLineReportOfCurrentUser } = props;
  const { t } = useTranslation();

  const dateRange = useMemo(() => {
    return `${moment(grouping.fromDate).format('D MMMM')} - ${moment(grouping.toDate).format('D MMMM')}`
  }, [grouping]);

  const showEditLink = useMemo(() => {
    if (isCompanyAdminUser(currentUser) || isLineReportOfCurrentUser) {
      return true;
    }

    if (!userInfo.userId || userInfo.userId === currentUser?.id) {
      return !moment(grouping.fromDate).isBefore(moment());
    }

    return false;
  }, [currentUser, isLineReportOfCurrentUser, userInfo.userId, grouping.fromDate]);

  const editLink = !!userInfo?.userId ? `/holidays/edit/${grouping.fromDate}/${userInfo?.userId}` : `/holidays/edit/${grouping.fromDate}/${currentUser?.id}`

  return (
    <>
      <SpaceBetweenRow>
        <LeaveTypeLabel whereaboutsId={grouping.whereaboutsId} />
        {showEditLink && <IconButton icon={IconTypes.Edit} link={editLink}/>}
      </SpaceBetweenRow>
      <DateRange>{dateRange}</DateRange>
      <ChipRow>
        {grouping.state === ApprovalState.pending && <OrangeChip size={'small'} label={'button.pending'} dataTest={"pending-chip"} onClick={() => {}} />}
        {grouping.state === ApprovalState.approved && <PrimaryChip size={'small'} label={'button.approved'} dataTest={"approved-chip"} onClick={() => {}} />}
        {grouping.numberOfDays > 0 && <OutlineChip label={t('holidays.holiday-duration', {duration: grouping.numberOfDays})} onClick={() => {}} size={'small'} />}
      </ChipRow>
    </>
  )
}

interface Props {
  grouping: CustomLeaveGrouping;
  currentUser?: User;
  userInfo: { userId?: string };
  isLineReportOfCurrentUser: boolean;
}

const ChipRow = styled.div`
  display: flex;
  align-items: center;
  &>* {
    margin-right: 8px;
  }
  p {
    font-weight: 700;
  }
`
